import { useNavigation } from '@atom/hooks/useNavigation';
import { usePreferences } from '@atom/hooks/usePreferences';
import logo from '@atom/images/logo.svg';
import { showTestEnvironmentLabel } from '@atom/utilities/featureToggleUtilities';
import { getPortals } from '@atom/utilities/portalUtilities';

import classes from './navigation.module.css';

const Logo = () => {
  const preferences = usePreferences();
  const [, { navigate, pathname }] = useNavigation();
  const landingPortal = getPortals(preferences)[preferences.landingPortal];
  const DASHBOARD_PATHS = ['/', landingPortal?.urlPath];

  const navigateToDashboard = () => {
    if (!DASHBOARD_PATHS.includes(pathname)) {
      navigate(landingPortal.urlPath);
    }
  };

  const isTestEnv = showTestEnvironmentLabel;

  return (
    <div className={isTestEnv ? classes.logoTestEnv : classes.logoContainer}>
      <img
        onClick={navigateToDashboard}
        src={logo}
        className={classes.logo}
        alt="Atom Logo"
      />
      {isTestEnv && (
        <div id="testEnv" className={classes.testDiv}>
          <span>Test Environment</span>
        </div>
      )}
    </div>
  );
};

export default Logo;
